import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowDownToLine, ArrowRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PlaybookCard = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || loading) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/playbook`, { email: email.trim() });
      setDownloadUrl(res.data.download_url);
      toast.success("Your playbook is ready — it's also on its way to your inbox.");
    } catch {
      toast.error("Something went wrong — please try again.");
    }
    setLoading(false);
  };

  return (
    <div data-testid="playbook-card" className="mt-14 border border-line bg-white/40 p-8 md:p-10">
      <p className="overline-label">Free Download</p>
      <h3 className="mt-4 font-serif text-2xl md:text-3xl font-light tracking-tight leading-tight">
        Enjoyed this? Get <em className="text-taupe">The Fractional CMO Playbook.</em>
      </h3>
      <p className="mt-3 text-sm font-light text-ash leading-relaxed max-w-lg">
        Ten questions to ask before you hire marketing leadership — the same lens
        behind every article in this journal.
      </p>
      {downloadUrl ? (
        <div data-testid="playbook-card-success" className="mt-6">
          <a
            data-testid="playbook-card-download-link"
            href={downloadUrl}
            download
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 bg-ink text-paper text-xs uppercase tracking-[0.2em] px-8 py-4 hover:bg-taupe transition-colors duration-300"
          >
            Download the Playbook
            <ArrowDownToLine size={14} className="transition-transform duration-300 group-hover:translate-y-0.5" />
          </a>
        </div>
      ) : (
        <form data-testid="playbook-card-form" onSubmit={onSubmit} className="mt-6 flex flex-col sm:flex-row gap-4 sm:items-end">
          <div className="flex-1">
            <label htmlFor="pbc-email" className="text-[10px] uppercase tracking-[0.25em] text-ash">
              Email address *
            </label>
            <input
              id="pbc-email"
              data-testid="playbook-card-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              className="mt-2 w-full bg-transparent border-b border-ink/20 focus:border-ink outline-none py-3 text-base font-light placeholder:text-ash/50 transition-colors duration-300"
            />
          </div>
          <button
            data-testid="playbook-card-submit-btn"
            type="submit"
            disabled={loading}
            className="group inline-flex items-center justify-center gap-2 bg-ink text-paper text-xs uppercase tracking-[0.2em] px-6 py-4 hover:bg-taupe disabled:opacity-50 transition-colors duration-300 shrink-0"
          >
            {loading ? <Loader2 size={14} className="animate-spin" /> : (
              <>Send It <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" /></>
            )}
          </button>
        </form>
      )}
    </div>
  );
};

export default PlaybookCard;
